import { render, staticRenderFns } from "./upDown.vue?vue&type=template&id=9696dc24&scoped=true&"
import script from "./upDown.vue?vue&type=script&lang=js&"
export * from "./upDown.vue?vue&type=script&lang=js&"
import style0 from "./upDown.vue?vue&type=style&index=0&id=9696dc24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9696dc24",
  null
  
)

export default component.exports